import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FieldNumberOutlinedSvg from "@ant-design/icons-svg/es/asn/FieldNumberOutlined";
import AntdIcon from "../components/AntdIcon";
var FieldNumberOutlined = function FieldNumberOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FieldNumberOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FieldNumberOutlined.displayName = 'FieldNumberOutlined';
}
export default /*#__PURE__*/React.forwardRef(FieldNumberOutlined);